import {Injectable} from '@angular/core';

@Injectable()
export class CameraService {

  canTakePhoto(): boolean {
    return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/camera-service/camera-service.ts